import React from 'react';
import PropTypes from 'prop-types';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';

const CommentsHeader = props => {
    const toggleExpand = () => {
        runInAction(() => {
            props.commentsStore.expanded = !props.commentsStore.expanded;
        });
    };

    const toggleResolved = () => {
        runInAction(() => {
            props.commentsStore.filters.resolved = !props.commentsStore.filters.resolved;
        });
    };

    const renderExpandAllBtn = () =>
        (<span
            className='tool icon-expand-all'
            title={gettext('Expand all')}
            onClick={toggleExpand}
            ga-action={props.commentsStore.GASettings.action}
            ga-label='Expand_All_Comments'
            data-what='comments-btn'
            data-which='expand-all'
        />);

    const renderCollapseAllBtn = () =>
        (<span
            className='tool icon-collapse-all'
            title={gettext('Collapse all')}
            onClick={toggleExpand}
            ga-action={props.commentsStore.GASettings.action}
            ga-label='Collapse_All_Comments'
        />);

    const renderToggleExpandBtn = () =>
        props.commentsStore.expanded
            ? renderCollapseAllBtn()
            : renderExpandAllBtn();

    return (<div className='comments-header'>
        <span className='title'>
            {`${gettext('Comments')} (${props.commentsStore.resourceComments.length})` }
        </span>
        {
            props.allowComments &&
            <span className='comments-tools'>
                <span
                    className={`tool icon-status-ok ${!props.commentsStore.filters.resolved ? 'tool-active' : ''}`}
                    title={
                        props.commentsStore.filters.resolved
                            ? gettext('Show resolved')
                            : gettext('Hide resolved')
                    }
                    onClick={toggleResolved}
                    ga-action={props.commentsStore.GASettings.action}
                    ga-label='Toggle_Resolved'
                    data-what='comments-btn'
                    data-which='toggle-resolved'
                />
                { renderToggleExpandBtn() }
            </span>
        }
        {
            props.commentsStore.loading && <div className='line-loading line-loading--bot' />
        }
    </div>);
};

export default observer(CommentsHeader);

CommentsHeader.propTypes = {
    commentsStore: PropTypes.object.isRequired,
    allowComments: PropTypes.bool
};
